import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Form,
  Input,
  Button,
  Checkbox,
  Row,
  Col,
  Card,
  Upload,
  Icon,
  message,
  Select,
} from "antd";
import {
  getItemDetail,
  syncOutlets,
} from "../../../../../../actions/fnbAction"; // Using getItemDetail generic or create specific getOutletDetail
import * as ANT from "antd";
import moment from "moment";
import RichTextEditor, {
  ClassicEditor,
} from "containers/backend/common/component/RichTextEditor";
import { UPLOAD_DIRECTORY } from "constants/Define";

const FormItem = Form.Item;

export default class OutletDetail extends Component {
  state = {
    fileList: [],
  };

  componentDidMount() {
    // Mocking fetching detail or implement getOutletDetail in action
    // For now assuming we load from list or fetch specific
    // this.props.actions.getOutletDetail(this.props.match.params.id);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        // Dispatch update action
        message.success("Configuration saved (mock)");
      }
    });
  };

  render() {
    const { t } = this.props;
    // Mock data for now, replace with this.props.outlet
    const outlet = {
      name: "Vinwonder GrandWorld Phú Quốc",
      restaurantName: "SK Thủy Cung Times City",
      code: "RES-001",
      openTime: "09:00",
      closeTime: "22:30",
      zone: "",
      restaurantType: "",
      cuisineType: "",
      onlineOrder: false,
      shortDescription:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ull",
      description: "",
    };

    const formItemLayout = {
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
    };

    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">Tải ảnh lên</div>
      </div>
    );

    return (
      <div
        className="outlet-detail-wrapper"
        style={{ padding: 24, background: "#fff" }}
      >
        <ANT.PageHeader
          onBack={() => this.props.history.goBack()}
          title={
            <span>
              Trang chủ / <span style={{ fontWeight: "normal" }}>Ẩm thực</span>
            </span>
          }
        />

        <Card
          title="Thông tin cơ bản"
          bordered={false}
          bodyStyle={{ padding: "0 24px" }}
        >
          <Form onSubmit={this.handleSubmit} layout="vertical">
            <Row gutter={24}>
              <Col span={24}>
                <FormItem label="Hình ảnh">
                  <Upload
                    name="avatar"
                    listType="picture-card"
                    className="avatar-uploader"
                    showUploadList={false}
                    action="/upload.do"
                  >
                    {uploadButton}
                  </Upload>
                </FormItem>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={12}>
                <FormItem label="Tên cơ sở">
                  <Input disabled value={outlet.name} />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem label="Tên nhà hàng">
                  <Input disabled value={outlet.restaurantName} />
                </FormItem>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={6}>
                <FormItem
                  label={
                    <span style={{ color: "red" }}>
                      *{" "}
                      <span style={{ color: "rgba(0, 0, 0, 0.85)" }}>
                        Loại nhà hàng
                      </span>
                    </span>
                  }
                >
                  <Select disabled value={outlet.restaurantType}>
                    <Select.Option value="type1">Type 1</Select.Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label={
                    <span style={{ color: "red" }}>
                      *{" "}
                      <span style={{ color: "rgba(0, 0, 0, 0.85)" }}>
                        Phân khu
                      </span>
                    </span>
                  }
                >
                  <Select disabled value={outlet.zone}>
                    <Select.Option value="zone1">Zone 1</Select.Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem label="Giờ mở cửa">
                  <ANT.TimePicker
                    format="HH:mm"
                    style={{ width: "100%" }}
                    value={moment(outlet.openTime, "HH:mm")}
                  />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem label="Giờ đóng cửa">
                  <ANT.TimePicker
                    format="HH:mm"
                    style={{ width: "100%" }}
                    value={moment(outlet.closeTime, "HH:mm")}
                  />
                </FormItem>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={6}>
                <FormItem
                  label={
                    <span style={{ color: "red" }}>
                      *{" "}
                      <span style={{ color: "rgba(0, 0, 0, 0.85)" }}>
                        Loại ẩm thực
                      </span>
                    </span>
                  }
                >
                  <Select disabled value={outlet.cuisineType}>
                    <Select.Option value="asian">Asian</Select.Option>
                  </Select>
                </FormItem>
              </Col>
              <Col
                span={6}
                style={{ display: "flex", alignItems: "center", marginTop: 40 }}
              >
                <FormItem>
                  <Checkbox disabled checked={outlet.onlineOrder}>
                    Đặt món online
                  </Checkbox>
                </FormItem>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={24}>
                <FormItem label="Mô tả ngắn">
                  <Input.TextArea rows={3} value={outlet.shortDescription} />
                </FormItem>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={24}>
                <FormItem label="Mô tả">
                  <RichTextEditor
                    ref={this.descriptionInputRef}
                    disabled={true}
                    editor={ClassicEditor}
                    data={outlet.description}
                    config={{ uploadDirectory: UPLOAD_DIRECTORY.OUTLET }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      return this.props.onChange("description", data);
                    }}
                  />
                </FormItem>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={24}>
                <FormItem label="Menu nhà hàng">
                  <Upload.Dragger name="files" action="/upload.do">
                    <p className="ant-upload-drag-icon">
                      <Icon type="cloud-upload" />
                    </p>
                    <p className="ant-upload-text">Drop files here</p>
                    <p className="ant-upload-hint">
                      Supported format: PNG, JPG
                    </p>
                  </Upload.Dragger>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span={24} style={{ textAlign: "right", marginTop: 20 }}>
                <Button
                  style={{ marginRight: 8 }}
                  onClick={() => this.props.history.goBack()}
                >
                  Quay về
                </Button>
                <Button type="primary" htmlType="submit">
                  Cập nhật
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>
      </div>
    );
  }
}
